import apiClient from "../../axios/apiClient";


export const getUserTypeList =
  (token, limit = 10, page = 1, search = "", sort = "desc") =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_USERTYPELIST_PENDING" });

      const response = await apiClient.get(
        `/api/admin/v1/Usertype`,
        {
          params: {
            limit: limit,
            page: page,
            search: search,
            sort: sort,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      //console.log('response.data?.data',response.data?.data);
      dispatch({
        type: "GET_USERTYPELIST_FULFILLED",
        payload: response.data?.data,
        usertypeCount: response.data?.count,
        permissions: response.data?.permissions,
      });
    } catch (error) {
      console.log(error);
      dispatch({
        type: "GET_USERTYPELIST_REJECTED",
        payload: error.response,
      });
    }
  };


  export const saveUserTypeData = (token, data) => async (dispatch) => {
    try {
      console.log('token, data', token, data);
      dispatch({ type: "ADD_USERTYPE_PENDING" });
  
      const response = await apiClient.post(
        `/api/admin/v1/Add-Usertype`,
        data, // Data payload should be the second argument
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({ type: "ADD_USERTYPE_FULFILLED", payload: response.data });
    } catch (error) {
      //console.log(error.response.data);
      dispatch({ type: "ADD_USERTYPE_REJECTED", payload: error.response });
    }
  };
  

  export const getUserTypeListById =(token,id) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_USERTYPELISTBYID_PENDING" });

      const response = await apiClient.get(
        `/api/admin/v1/Usertype/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      //console.log('response.data?.data',response.data?.data);
      dispatch({
        type: "GET_USERTYPELISTBYID_FULFILLED",
        payload: response.data?.data,
        usertypeCount: response.data?.count,
      });
    } catch (error) {
      console.log(error);
      dispatch({
        type: "GET_USERTYPELISTBYID_REJECTED",
        payload: error.response,
      });
    }
  };


export const updateUserTypeData = (token, data, id) => async (dispatch) => {
  try {
    console.log('token, data', token, data);
    dispatch({ type: "UPDATE_USERTYPE_PENDING" });

    const response = await apiClient.post(
      `/api/admin/v1/Update-Usertype/${id}`, // Endpoint URL with City ID
      data, // Data payload
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "UPDATE_USERTYPE_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "UPDATE_USERTYPE_REJECTED", payload: error.response });
  }
};

export const updateUserTypeStatusData = (token, id,status) => async (dispatch) => {
  try {
    dispatch({ type: "UPDATE_USERTYPE_STATUS_PENDING" });
    const data={
      "status":status
    }
    const response = await apiClient.post(
      `/api/admin/v1/Update-Usertype-Status/${id}`, // Endpoint URL with City ID
      data, // Data payload
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "UPDATE_USERTYPE_STATUS_FULFILLED", payload: response.data });
  } catch (error) {
    console.log('error',error)
    dispatch({ type: "UPDATE_USERTYPE_STATUS_REJECTED", payload: error.response });
  }
};


export const deleteUserTypeData = (token, id) => async (dispatch) => {
  try {
    console.log('token, id', token, id);
    dispatch({ type: "DELETE_USERTYPE_PENDING" });

    const response = await apiClient.delete(
      `/api/admin/v1/Delete-Usertype/${id}`, // Endpoint URL with City ID
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "DELETE_USERTYPE_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "DELETE_USERTYPE_REJECTED", payload: error.response });
  }
};